import { useState } from "react";

const navLinks = [
  { id: "trending", label: "今日热榜" },
  { id: "category", label: "分类索引" },
  { id: "topic", label: "专题目录" },
  { id: "map", label: "知识图谱" },
  { id: "about", label: "关于我们" },
  { id: "faq", label: "常见问题" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  return (
    <header
      className="sticky top-0 z-50 transition-all duration-300"
      onMouseEnter={() => setScrolled(true)}
      onMouseLeave={() => setScrolled(false)}
    >
      <nav
        className={
          "transition-all duration-300 " +
          (scrolled
            ? "bg-background-50/95 backdrop-blur shadow-none border-b border-background-200"
            : "bg-transparent")
        }
      >
        <div className="mx-auto flex w-full items-center justify-between px-4 md:px-6 py-3.5">
          <a href="#hero" className="flex items-center gap-2.5 whitespace-nowrap">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-community-line text-lg"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span className="font-display text-lg font-bold text-foreground-950">吃瓜百科</span>
              <span className="text-[10px] text-foreground-500 mt-0.5 tracking-wide">GOSSIP WIKI</span>
            </span>
          </a>

          <ul className="hidden lg:flex items-center gap-1">
            {navLinks.map((l) => (
              <li key={l.id}>
                <a
                  href={"#" + l.id}
                  className="block whitespace-nowrap rounded-lg px-3.5 py-2 text-sm text-foreground-700 hover:bg-background-200/70 hover:text-primary-700 transition-colors"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="hidden lg:flex items-center gap-2">
            <a
              href="#trending"
              className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-secondary-500 px-4 py-2 text-sm font-medium text-background-50 hover:bg-secondary-600 transition-colors"
            >
              <i className="ri-fire-fill"></i>
              去热榜逛逛
            </a>
          </div>

          <button
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 bg-background-50/80 text-foreground-800 lg:hidden"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
          >
            <i className={"text-xl " + (open ? "ri-close-line" : "ri-menu-line")}></i>
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50/98 lg:hidden">
            <div className="mx-auto flex flex-col gap-1 px-4 py-3">
              {navLinks.map((l) => (
                <a
                  key={l.id}
                  href={"#" + l.id}
                  onClick={() => setOpen(false)}
                  className="flex items-center gap-2 whitespace-nowrap rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-background-200/70"
                >
                  <i className="ri-arrow-right-s-line text-primary-500"></i>
                  {l.label}
                </a>
              ))}
              <a
                href="#trending"
                onClick={() => setOpen(false)}
                className="mt-2 inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors"
              >
                <i className="ri-fire-fill"></i>
                去热榜逛逛
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}